<template>
  <div class="removeDust_historicalTrend _boxBg_dark_big absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">
      脱硫脱硝除尘系统实时监控
    </div>
    <div class="_blueLine"></div>
    <el-row>
      <el-col :span="24" :style="{ textAlign: 'center',marginTop: '10px'}">
        <div class="dot1">•</div>
        <div class="dot1-title">≤80%限值</div>

        <div class="dot2">•</div>
        <div class="dot1-title">＞80%限值且≤限值</div>

        <div class="dot3">•</div>
        <div class="dot1-title">＞限值</div>
      </el-col>
    </el-row>
    <div class="_innerBox">
      <ul class="outUl">

        <li class="outLi" v-for="(child, j) in Object.keys(dashboardData)" :key="j">
          <div class="li_title">{{ child }}</div>
          <div class="li_content">
            <ul class="inUl">
              <li class="inLi" v-for="(item,i) in dashboardData[child]" :key="i">
                <div class="li_box_chart">
                  <ul class="li_box_chart_ul">
                    <li class="li_box_chart_li" v-for="(bar,i_) in item.list" :key="i_">
                      <div class="histogram-bar-name">{{bar.value_name}}</div>
                      <div class="histogram-bar-bg">
                        <div class="histogram-bar" :class="getColor(bar.value,bar.standard_data)"
                          :style="{width: ( bar.value / (bar.standard_data * 1.2) < 1) ? ( bar.value / (bar.standard_data * 1.2)) * 100 + '%':'100%'}">
                        </div>
                      </div>
                      <div class="histogram-bar-value">{{bar.value}}</div>
                    </li>
                  </ul>
                </div>
                <div class="li_box_title">{{item.deviceName}}</div>
              </li>
            </ul>
          </div>
        </li>
        <!-- <li class="outLi">
          <div class="li_title">能源部</div>
          <div class="li_content">
            <ul class="inUl">
              <li class="inLi" v-for="(item,i) in dashboardData['能源部']" :key="i">
                <div class="li_box_chart">
                  <ul class="li_box_chart_ul">
                    <li class="li_box_chart_li" v-for="(bar,i_) in item.list" :key="i_">
                      <div class="histogram-bar-name">{{bar.value_name}}</div>
                      <div class="histogram-bar-bg">
                       <div class="histogram-bar" :class="getColor(bar.value,bar.standard_data)"
                          :style="{width: ( bar.value / (bar.standard_data * 1.2) < 1) ? ( bar.value / (bar.standard_data * 1.2)) * 100 + '%':'100%'}">
                        </div>
                      </div>
                      <div class="histogram-bar-value">{{bar.value}}</div>
                    </li>
                  </ul>
                </div>
                <div class="li_box_title">{{item.deviceName}}</div>
              </li>
            </ul>
          </div>
        </li>
        <li class="outLi">
          <div class="li_title">炼钢部</div>
          <div class="li_content">
            <ul class="inUl">
              <li class="inLi" v-for="(item,i) in dashboardData['炼钢部']" :key="i">
                <div class="li_box_chart">
                  <ul class="li_box_chart_ul">
                    <li class="li_box_chart_li" v-for="(bar,i_) in item.list" :key="i_">
                      <div class="histogram-bar-name">{{bar.value_name}}</div>
                      <div class="histogram-bar-bg">
                        <div class="histogram-bar" :class="getColor(bar.value,bar.standard_data)"
                          :style="{width: ( bar.value / (bar.standard_data * 1.2) < 1) ? ( bar.value / (bar.standard_data * 1.2)) * 100 + '%':'100%'}">
                        </div>
                      </div>
                      <div class="histogram-bar-value">{{bar.value}}</div>
                    </li>
                  </ul>
                </div>
                <div class="li_box_title">{{item.deviceName}}</div>
              </li>
            </ul>
          </div>
        </li> -->
      </ul>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import getOpt from "./chartOpt.js";
import { unwarp } from "@/utils/tools.js";

export default {
  title: "脱硫脱硝除尘系统实时监控",
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  data() {
    return {
      customerId: this.globalInstance.$store.state.customerId,
      paramsData: {
        customerId: 8,
        type: 1,
      },
      dashboardData: {},
      INTERVAL: null,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    getColor() {
      return function (value, standard_data) {
        if (Number(value) <= 0.8 * Number(standard_data)) {
          return "blue";
        } else if (
          Number(value) > 0.8 * Number(standard_data) &&
          Number(value) <= Number(standard_data)
        ) {
          return "yellow";
        } else {
          return "red";
        }
      };
    },
  },
  methods: {
    formatDateTime(inputTime) {
      inputTime = parseInt(inputTime);
      if (inputTime) {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      }
    },
    async getData() {
      if (this.INTERVAL) {
        clearTimeout(this.INTERVAL);
        this.INTERVAL = null;
      }
      let getQgDevicesByType =
        CONFIG.requestName + this.globalInstance.$apiOpt.getQgDevicesByType;
      let data = await this.globalInstance.$apiUtils.get(
        getQgDevicesByType,
        this.paramsData
      );
      this.dashboardData = data;
      this.INTERVAL = setTimeout(() => {
        this.getData();
      }, 30 * 1000);
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.removeDust_historicalTrend {
  ._innerBox {
    overflow: auto;
    ul.outUl {
      width: 90%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      li.outLi {
        width: calc((100% - 80px) / 3);
        height: 100%;
        .li_title {
          height: 50px;
          font-size: 26px;
          font-weight: 500;
          color: #dddddd;
          line-height: 50px;
          text-align: center;
          background: rgba(1, 18, 43, 0.81);
          border: 1px solid rgba(132, 170, 255, 0.5);
          border-left: 0px;
          border-right: 0px;
        }
        .li_content {
          min-height: 654px;
          background: linear-gradient(
            180deg,
            rgba(108, 151, 255, 0.2) 0%,
            rgba(107, 151, 255, 0.2) 78%,
            rgba(58, 116, 255, 0.1) 100%
          );
          ul.inUl {
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-decoration: none;
            padding: 30px;
            &::after {
              content: "";
              height: 0;
              width: 313px;
              // flex: auto;
            }
            li.inLi {
              margin-bottom: 20px;
              display: inline-block;
              width: 313px;
              height: 148px;
              background: rgba(0, 0, 0, 0.2);
              box-shadow: 0px 1px 1px 0px rgba(46, 130, 255, 0.41);
              border: 1px solid;
              border-image: linear-gradient(
                  90deg,
                  rgba(46, 74, 117, 1),
                  rgba(46, 130, 255, 0),
                  rgba(1, 191, 165, 0)
                )
                1 1;
              .li_box_chart {
                height: 118px;
                .li_box_chart_ul {
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                  .li_box_chart_li {
                    height: 22px;
                    display: flex;
                    align-items: center;
                    .histogram-bar-name {
                      font-size: 16px;
                      font-weight: 400;
                      color: #e4fcff;
                      line-height: 16px;
                      text-align: right;
                      width: 85px;
                      overflow: hidden;
                      white-space: nowrap;
                      margin-right: 5px;
                    }
                    .histogram-bar-bg {
                      margin-right: 5px;
                      width: 143px;
                      position: relative;
                      height: 20px;
                      background: rgba($color: #000000, $alpha: 0.3);
                      border: 1px solid rgba($color: #000000, $alpha: 0.3);
                      .histogram-bar {
                        position: absolute;
                        left: 0;
                        top: 1;
                        height: 20px;
                        background: linear-gradient(
                          270deg,
                          #d7f1ff 0%,
                          #79a9ff 100%
                        );
                        border-radius: 0px 2px 2px 0px;
                        transition: width 1s linear 2s;
                      }
                      .blue {
                        background: linear-gradient(
                          270deg,
                          #d7f1ff 0%,
                          #79a9ff 100%
                        );
                      }
                      .yellow {
                        background: linear-gradient(
                          270deg,
                          #faebcb 0%,
                          #f4d29c 100%
                        );
                      }
                      .red {
                        background: linear-gradient(
                          270deg,
                          #ffb0b0 0%,
                          #ff7878 100%
                        );
                      }
                    }
                    .histogram-bar-value {
                      font-size: 16px;
                      font-weight: 400;
                      color: #99f5ff;
                      line-height: 16px;
                      width: 70px;
                      text-align: right;
                      padding-right: 5px;
                    }
                  }
                }
              }
              .li_box_title {
                height: 30px;
                text-align: center;
                background: rgba(0, 0, 0, 0.2);
                box-shadow: 0px 1px 1px 0px rgba(46, 130, 255, 0.41);
                border: 1px solid;
                border-image: linear-gradient(
                    90deg,
                    rgba(46, 74, 117, 1),
                    rgba(46, 130, 255, 0),
                    rgba(1, 191, 165, 0)
                  )
                  1 1;
                font-size: 14px;
                color: #c0d5d9;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
}

.chart {
  margin-top: 20px;
  width: 100%;
  height: 260px;
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #f5a623;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: "fontNormal";
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
<style type="text/css">
._boxBg_dark .el-form-item__label {
  color: #99f5ff !important;
  font-weight: 500;
}
._boxBg_dark .el-form-item__content {
  border-radius: 2px !important;
  border: 1px solid !important;
  border-image: linear-gradient(90deg, #2e31ff, #01b0bf) 1 1 !important;
}

._boxBg_dark ._boxBg_dark_select {
  height: 40px;
}

._boxBg_dark ._boxBg_dark_select .el-input__inner {
  font-size: 16px;
}
</style>